document.addEventListener('DOMContentLoaded', function () {
    (function (window, document) {

        let links = Array.prototype.slice.call(
            document.querySelectorAll('[data-href]')
        );

        links.forEach(function (link) {
            let link_href = link.dataset.href;

            link.querySelectorAll('button, a').forEach(child => {
                child.addEventListener('click', function (event) {
                    event.stopPropagation();
                });
            });

            link.addEventListener('click', function (event) {
                window.location.href = link_href;
            });
        });

    })(window, document);
});
